import { takeLatest, select, put, all } from 'redux-saga/effects';
import { runAutoCalc, calcPropertyUWProforma, appNotify, setChannelWorkflowLoadingOverlayState, setTransientValuation } from 'store/actions';
import { transientValuationSelector, selectedProformaInputsSelector, selectedOpportunitySelector } from 'store/selectors';
import { postWithToken } from 'api/network';

export function* calcProformaSaga() {
    yield takeLatest(runAutoCalc, function* ({ payload: txnOppIds }) {
        try {
            yield put(setChannelWorkflowLoadingOverlayState({ isLoading: true, message: 'Calculating with repairs...' }));

            // Call backend to calculate and save valuations for this portfolio
            const response = yield postWithToken(`/api/underwrite/auction/applyInspectionRepairs`, txnOppIds);
            const calculatedValuations = yield response.json();

            yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
            if (calculatedValuations?.length > 0) {
                yield put(appNotify(`${calculatedValuations.length} ${calculatedValuations.length > 1 ? 'calculations' : 'calculation'} finished`, 'success'));
            }
            else {
                yield put(appNotify('No calculation has been performed on server', 'warning'));
            }
        }
        catch (e) {
            yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
            yield put(appNotify(`Calculation Error: ${e.message}`, 'error'));
        }
    });

    yield takeLatest(calcPropertyUWProforma, function* () {
        try {
            yield put(setChannelWorkflowLoadingOverlayState({ isLoading: true, message: 'Calculating...' }));
            const [transientValuation, selectedProformaInputs, selectedOpportunity] = yield all([
                select(transientValuationSelector),
                select(selectedProformaInputsSelector),
                select(selectedOpportunitySelector),
            ]);

            const response = yield postWithToken(`/api/underwrite/prop/proformainputs/${selectedProformaInputs.id}/calculate?channel=${selectedOpportunity.channelText}`, transientValuation);
            const calculatedValuation = yield response.json();

            yield put(setTransientValuation(calculatedValuation));
            yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
            setTimeout(() => put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null })), 1000); // give it a little extra time to make sure loading overlay shows up
        }
        catch (e) {
            yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
            yield put(appNotify(e.message, 'error'));
        }
    });
}